<template>
  <div>
    <!-- //^ ^--------------查看/新增/编辑的对话框-------------^ ^ -->
    <el-dialog
      :title="title"
      :visible.sync="dialog.visible"
      append-to-body
      :modal-append-to-body="false"
      @closed="closed"
      :close-on-click-modal="true"
      width="40%"
    >
      <div>
        <!-- 表单 -->
        <el-form
          ref="form"
          :disabled="dialog.disabled"
          :model="form"
          :rules="rules"
          label-width="150px"
        >
          <el-form-item label="标题：" prop="name">
            <el-input
              style="width: 250px"
              clearable
              v-model="form.name"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="内容：" prop="content">
            <el-input
              style="width: 250px"
              v-model="form.content"
              clearable
              placeholder="请输入内容"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="跳转链接：" prop="link">
            <el-input
              v-model="form.link"
              placeholder="请输入跳转链接"
              style="width: 250px"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 保存-取消 -->
      <span v-show="!dialog.disabled" slot="footer" style="flex-end">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="confirm"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Message from "@/components/Message";
import { addPush, editPush } from "@/api/runActivityManage/pushManage";
export default {
  name: "WebSassAdd",
  computed: {
    title() {
      return this.dialog.title;
    },
  },
  data() {
    return {
      /** 表单 */
      form: {
        id: "",
        title: "",
        content: "",
        url: "",
      },
      /** 表单验证规则 */
      rules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        link: [{ required: true, message: "请输入跳转链接", trigger: "blur" }],
      },
      dialog: {
        visible: false,
        title: "",
        disabled: false,
      },
    };
  },
  methods: {
    // ^ ^--------------对话框内的事件-------------^ ^
    /** 确认的事件 */
    confirm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          /** 验证通过 */
          if (this.dialog.title === "创建Push") {
            const params = { ...this.form };
            const { data } = await addPush(params);
            if (data.code === 200) {
              Message.success("创建成功");
            }
          } else {
            const params = { ...this.form };
            const { data } = await editPush(params);
            if (data.code === 200) {
              Message.success("编辑成功");
            }
          }
          this.hide();
        } else {
          /** 验证失败 */
          Message.error("请检查表单");
        }
      });
    },
    show(title, isDisabled, row) {
      this.dialog.title = title;
      this.dialog.disabled = isDisabled;
      this.dialog.visible = true;
      console.log("拿到的row", row);
      if (row) {
        const params = { ...row };
        this.form = params;
      }
    },
    hide() {
      this.dialog.visible = false;
      this.$emit("reload");
    },
    closed() {
      console.log("closed");
      /** 清理表单数据 */

      if (this.$refs.form) {
        this.form = {
          id: "",
          name: "",
          goods: "",
          time: "",
          period: "",
          price: "",
          show: "",
          status: "",
          remark: "",
        };
      }
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      console.log("form", this.$refs.form);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  padding-right: 50px !important;
}

::v-deep .el-textarea__inner {
  padding-right: 55px !important;
  max-height: 100px !important;
}
</style>